var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: { actions: _vm.pageActionConfig, page: _vm.pageConfig }
      }),
      _c("board", {
        staticClass: "mb-4",
        attrs: { details: _vm.detailsBoard }
      }),
      _c("custom-separator", {
        staticClass: "my-4",
        attrs: { text: "Resultados" }
      }),
      _vm.response?.documents.length === 0
        ? _c("custom-result-not-found", {
            attrs: { text: "No hay información disponible." }
          })
        : _vm._e(),
      _vm._l(_vm.response?.documents, function(result, index) {
        return _c("div", { key: index, staticClass: "result-item" }, [
          _c("div", { staticClass: "result-content" }, [
            _c("div", { staticClass: "row col-12" }, [
              _c("div", { staticClass: "row col-12" }, [
                _c(
                  "div",
                  { staticClass: "col-12 col-md-8" },
                  [
                    _c("section-title", {
                      staticClass: "mt-4",
                      attrs: {
                        id: "reinbursement-document-title",
                        "has-line": "",
                        title: result.documentTypeName
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-4 d-flex align-items-center justify-content-end"
                  },
                  [
                    _c("action-button", {
                      staticClass: "px-1 mx-1 download-btn",
                      attrs: {
                        i: "fas fa-file-download px-2 mx-0",
                        variant: "success"
                      },
                      on: {
                        click: function($event) {
                          return _vm.onDownload(result.documentId)
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _c("pre", { staticClass: "ml-4" }, [
              _vm._v(_vm._s(result.aiExtractionJsonResult))
            ])
          ])
        ])
      }),
      _vm.response?.documents.length > 0
        ? _c("div", { staticClass: "result-item" }, [
            _c(
              "div",
              { staticClass: "result-content" },
              [
                _c("section-title", {
                  staticClass: "mt-4",
                  attrs: {
                    id: "reinbursement-document-title",
                    "has-line": "",
                    title: "Resultado"
                  }
                }),
                _c("div", { staticClass: "row" }, [
                  _vm.response.isEligibleForApproval
                    ? _c(
                        "div",
                        { staticClass: "col-12 col-md-3 mt-4" },
                        [
                          _c("custom-balloon", {
                            staticClass: "w-md-90 w-100 m-0",
                            attrs: {
                              "background-color": "bg-green",
                              text: "Aprobación Sugerida"
                            }
                          })
                        ],
                        1
                      )
                    : _c(
                        "div",
                        { staticClass: "col-12 col-md-3 mt-4" },
                        [
                          _c("custom-balloon", {
                            staticClass: "w-md-90 w-100 m-0",
                            attrs: {
                              "background-color": "bg-yellow",
                              text: "No Sugerido para Aprobación"
                            }
                          })
                        ],
                        1
                      )
                ])
              ],
              1
            )
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }